import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import {Loading} from '../../components';

const ChartScore = ({
                        data,
                        myMatch,
                        width,
                        height,
                        label,
                        gridColor = "#C5C5C5",
                        marginBottom = 5,
                        marginTop = 5,
                        time
                    }) => {


    // 포지션 찾기
    let side = myMatch.side === 'BLUE' ? 'B_' : 'R_';
    let lane = '';
    switch (myMatch.position) {
        case 'Top':
            lane = 'Top';
            break;
        case 'Jungle':
            lane = 'Jun';
            break;
        case 'Middle':
            lane = 'Mid';
            break;
        case 'Bot':
            lane = 'Bot';
            break;
        case 'Supporter':
            lane = 'Sup';
            break;
        default:
            break;
    }
    const position = side + lane;
    const xAxisArr = data !== 'remake match' && Object.values(data.concat_seq_dict).map((data) => data[position]);
    const scoreArr = data !== 'remake match' && Object.values(data.concat_seq_dict).map((data) => data[position] < 0 ? 1 : data[position]);


    const getFiveArray = (arr) => {
        if (Array.isArray(arr)) {
            const copyArr = [...arr];
            const divideValue = 5;
            const lastValue = copyArr[copyArr.length - 1] % divideValue;
            let maxValue;
            if (lastValue === 0) {
                maxValue = copyArr[copyArr.length - 1];
            } else {
                maxValue = copyArr[copyArr.length - 1] + (divideValue - lastValue)
            }


            const result = arr.map((data, index) => {
                return (divideValue / (maxValue / copyArr.length) - 0.1) * index;
            });

            return {array: result, maxValue: 15};
        } else {
            return [];
        }
    }


    const options = {
        chart: {
            type: 'line',
            marginBottom: marginBottom,
            marginTop: marginTop,
            plotBackgroundColor: 'rgba(255,255,255,0.3)',
            backgroundColor: 'none',
            width: width,
            height: height,
            events: {
                load: function () {
                    let point = this.series[0].points;
                    point.forEach((p, i) => {
                        if (Number(Math.max.apply(null, scoreArr)) === Number(p.y)) {
                            p.update({
                                marker: {
                                    enabled: true,
                                    fillColor: '#36AE8D',
                                    radius: 4,
                                    width: 4,
                                    lineColor: '#ffffff',
                                    lineWidth: 2,
                                },
                            });
                        }
                    });
                },
            },
        },
        series: [
            {
                pointPlacement: "on",
                yAxis: 1,
                name: 'my score',
                type: 'line',
                showInLegend: false,
                data: scoreArr,
                zones: [
                    {
                        value: 24,
                        color: '#69788d',
                    },
                    {
                        value: 49,
                        color: '#de5353',
                    },
                    {
                        value: 75,
                        color: '#259a7e',
                    },
                    {
                        color: '#f19000',
                    },
                ],
                lineWidth: 2,

            },
        ],
        credits: {
            enabled: false,
        },
        title: {
            text: '',
        },
        subtitle: {
            text: '',
        },
        legend: {},
        xAxis: {
            margin: 0,
            title: {
                enabled: false,
            },
            labels: {
                enabled: false,
            },
            lineWidth: 1,
            lineColor: 'rgba(0,0,0,0.5)',
            gridLineWidth: 1,
            gridLineColor: gridColor,
            tickColor: 'transparent',
            // [0,3.5,7,10.5,20,25,30,35,40], // 보여지는 x축 값
            tickPositions: xAxisArr.map((data, index) => xAxisArr.length / (time / 300) * index),
            // tickPositions: getFiveArray(xAxisArr).array, // 보여지는 x축 값
        },
        yAxis: [{
            lineWidth: 1,
            lineColor: 'rgba(0,0,0,0.5)',
            title: {enabled: false},
            labels: {enabled: false},
            minorGridLineWidth: 0,
        }, {
            title: {
                enabled: false,
            },

            labels: {
                enabled: label,
                style: {
                    fontFamily: 'Noto Sans KR',
                    fontSize: '10px',
                    color: '#313131',
                },
                x: 5,
            },
            opposite: true,
            lineWidth: 0,
            lineColor: 'rgba(0,0,0,0.5)',
            gridLineWidth: 0,
            tickPositioner: function () {
                const positions = [];
                if (this.dataMax !== null && this.dataMin !== null) {
                    positions.push(Math.ceil(this.dataMin) - 1);
                    positions.push(Math.ceil((this.dataMax + this.dataMin) / 2));
                    positions.push(Math.ceil(this.dataMax) + 1);
                }
                return positions;
            },
            plotLines: [
                {
                    color: 'rgba(0, 0, 0, 0.4)',
                    width: 1,
                    zIndex: 1,
                    value: 50,
                    dashStyle: 'Dash',
                },
            ],
            minorGridLineWidth: 1,
            minorGridLineColor: gridColor,
            minorTickInterval: 15,
        }],
        plotOptions: {
            series: {
                shadow: true,
                dataLabels: {
                    enabled: false,
                },
                marker: {
                    enabled: false,
                },
                states: {
                    hover: {
                        enabled: false,
                    },
                },
            },
        },

        tooltip: {
            enabled: false,
        },
    };

    return (
        <>
            {scoreArr !== undefined && scoreArr.length !== 0 && (
                <HighchartsReact highcharts={Highcharts} options={options}/>
            )}
        </>
    );
};

export default ChartScore;
